import nullsToUndefined from "../nullsToUndefined";

type GraphqlResponse<T> = {
  data?: T;
  errors?: Array<{ message?: string; path?: unknown }>;
};

const toJson = async <T>(response: Response): Promise<GraphqlResponse<T>> =>
  nullsToUndefined(await response.json()) as GraphqlResponse<T>;

export default toJson;
